import { inject, Injectable } from "@angular/core";
import { OAuthService } from "angular-oauth2-oidc";
import { TokenService } from "@auth/services/token.service";
import { ApiService } from "@api/services/api.service";
import { Observable } from "rxjs";
import { SessionStorageService } from "@shared/services/session-storage.service";
import { LoaderService } from "@layout/services/loader.service";
import { SessionStorageKeys } from "@shared/services/static/session-storage-keys";

@Injectable({
    providedIn: "root",
})
export class AuthService {
    private readonly oauthService = inject(OAuthService);
    private readonly loaderService = inject(LoaderService);
    private readonly tokenService = inject(TokenService);
    private readonly apiService = inject(ApiService);
    private readonly sessionStorageService = inject(SessionStorageService);

    public getClientAuthJwt(): Observable<string> {
        const authCode = this.sessionStorageService.getItem(
            SessionStorageKeys.AuthCode,
        );
        const query = authCode ? `?code=${authCode}` : "";

        return this.apiService.get<string>(`api/auth/client-assertion${query}`);
    }

    public isAuthorized(): boolean {
        return this.oauthService.hasValidAccessToken();
    }

    public isAcwAdmin(): boolean {
        return this.tokenService.hasPermissions(["acwadmin"]);
    }

    public isAcwUser(): boolean {
        return this.tokenService.hasPermissions(["acw"]);
    }

    public logout() {
        this.loaderService.showLoader();
        sessionStorage.clear();
        this.oauthService.logOut();
    }
}
